import { createSelector } from 'reselect';

import { StateType } from '../../index';
import { activeTabIndexSelector, currentChildActiveTabLessOne } from '../../EditorReducer/EditorSelector';

export const dataSelector = (state: StateType) => state.getIn(['simulation', 'data']);

export const tabDataSelector = createSelector(
  dataSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (data, index) => data && data.get(index)
);

export const dataIsSuperAlphaSelector = createSelector(
  dataSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (data, index) => data && data.getIn([index, 'superAlpha'])
);

export const dataFetchingCheckSelector = createSelector(
  dataSelector,
  activeTabIndexSelector,
  // @ts-ignore
  (data, index) => data && data.getIn([index, 'fetchingCheck'])
);

export const fetchingSelectionCodeSelector = createSelector(tabDataSelector, data => data && data.get('selectionCodeFetching'));

export const alphasSelectionCodeSelector = createSelector(tabDataSelector, data => data && data.get('alphasFromSelectionCode'));

export const alphaDetailSimulationSelector = createSelector(tabDataSelector, currentChildActiveTabLessOne, (tab, childIndex) => {
  if (tab) {
    if (childIndex >= 0) {
      return tab && tab.getIn(['children', childIndex, 'alphaDetail']);
    } else {
      return tab && tab.get('alphaDetail');
    }
  }

  return null;
});

export const alphaDetailIdSimulationSelector = createSelector(alphaDetailSimulationSelector, alphaDetail =>
  alphaDetail ? alphaDetail.get('id') : null
);

export const isFetchingPropertiesSimulationSelector = createSelector(tabDataSelector, currentChildActiveTabLessOne, (tab, childIndex) => {
  if (tab) {
    if (childIndex >= 0) {
      return tab && tab.getIn(['children', childIndex, 'fetchingAlphaPropertiesPatch']);
    } else {
      return tab && tab.get('fetchingAlphaPropertiesPatch');
    }
  }

  return null;
});
